import { render, staticRenderFns } from "./editDriverForm.vue?vue&type=template&id=c0486142"
import script from "./editDriverForm.vue?vue&type=script&lang=js"
export * from "./editDriverForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports